import React, { useState, useEffect } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TENANT_IMAGE_BASE_URL } from '@kfc-global/react-shared/config/config.constants';
import { config } from '@kfc-global/react-shared/config/config.utils';
import ModalComponent from 'molecules/Modal';
import { ButtonComp } from 'atoms/Buttons';
import { isMobileDevice, getValueOrDefaultObject } from 'common/utilities/utils';
import { getCouponDate } from 'organisms/CouponsLanding/utils/CouponUtils';
import { PROMOS_AND_REWARDS_CONSTANT } from '../Constants/PromosRewardsConstant';
import { RESIZE } from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import ImageComponent from 'atoms/Image/Container/ImageComponent';

const { Error_Yellow } = IMAGE_PATH;
const { DEFAULT_IMAGE_PATH, VIEW_DETAIL_IMAGE_PATH } = PROMOS_AND_REWARDS_CONSTANT;
const { VIEW_DETAILS, VALID_TO, REVEIW_CONDITION, GOT_IT_BUTTON, NO_IMAGE } = TRANSLATE_MAPPING_KEY;

export const ViewDetailsModal = props => {
  const {
    isDealModalOpen: isProductModalOpen,
    handleClose,
    viewDetailsData,
    tenantId,
  } = getValueOrDefaultObject(props);
  const { item } = getValueOrDefaultObject(viewDetailsData);
  const { imageName, validityEndTime, titleValue, termsAndConditions, legalText, hideEndDate } =
    getValueOrDefaultObject(item);
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));

  const TermsAndConditionsList = () => {
    return termsAndConditions?.map((itemVal, index) => {
      return (
        <li key={index}>
          <span>{itemVal?.message}</span>
        </li>
      );
    });
  };

  const modalProps = {
    id: 'viewDetailsPopUp',
    role: 'dialog',
    modalTitleId: 'viewDetailsPopUp',
    show: { isProductModalOpen },
    classNames: 'view-details-wrapper-modal white-background',
    showCloseBtn: true,
    closeButtonHandler: handleClose,
    modalTitle: translateWithI18Next(VIEW_DETAILS),
    autoFocus: true,
  };

  /**
   * useEffect to add and cleanup of window resize event
   */
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
    return () => {
      window.removeEventListener(RESIZE, windowResized);
    };
  });

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  return (
    <React.Fragment>
      <ModalComponent {...modalProps} data-testid='offers-deals-modal-testid'>
        <div className='view-details-wrapper'>
          <div className='view-details-img'>
            <ImageComponent
              srcFile={`${config(TENANT_IMAGE_BASE_URL)}${tenantId}${VIEW_DETAIL_IMAGE_PATH}${imageName}`}
              alt={translateWithI18Next(NO_IMAGE)}
              defaultPath={`${config(TENANT_IMAGE_BASE_URL)}${tenantId}${DEFAULT_IMAGE_PATH}`}
              className='veiw-detail-img-section'
            />
          </div>
          <div className='veiw-detail-section'>
            <h5 className='delivery-content'>{titleValue}</h5>
            <div className='view-details-small-text'>
              <div>{!hideEndDate && `${translateWithI18Next(VALID_TO)} ${getCouponDate(validityEndTime)}`}</div>
              <div>{legalText}</div>
            </div>
            {termsAndConditions?.length && (
              <div className='review-condition'>
                <div className='condition-wrapper'>
                  <ImageComponent srcFile={Error_Yellow} className='location-alert-icon' />
                  <div className='review-text'>{translateWithI18Next(REVEIW_CONDITION)}</div>
                </div>
              </div>
            )}

            <div className='list-item'>
              <TermsAndConditionsList />
            </div>
            <div className='offers-modal-deals-footer got-it-button-container'>
              <ButtonComp
                data-testid='got-it-button'
                disabled={false}
                onClick={() => handleClose()}
                className='got-it-button'
              >
                <span className='btn-text'>{translateWithI18Next(GOT_IT_BUTTON)}</span>
              </ButtonComp>
            </div>
          </div>
        </div>
      </ModalComponent>
    </React.Fragment>
  );
};

export default ViewDetailsModal;
